export enum MilestoneStatusEnum {
	Pending = 1,
	Active = 2,
	Cancelled = 3,
	Completed = 4,
	Archived = 5,
	Suspended = 6,
	Deleted = 7,
	Paused = 8,
	Expired = 9,
	Rejected = 10,
	Accepted = 11,
}

export enum MilestonePaymentStatusEnum {
	Pending = 1,
	Requested = 2,
	Released = 3,
	Completed = 4,
	Archived = 5,
	Suspended = 6,
	Deleted = 7,
	Paused = 8,
	Expired = 9,
	Rejected = 10,
	Accepted = 11,
	Funded = 12,
	Failed = 13,

}


